<img [src]="host + '/' + logo" style="width:5rem;" /><br>
<div class="mb-5 mt-3">
    <h1 class="display">Ticket Scanner</h1>
    <small class="text-white-50">by SmartNow</small>
</div>